import React, { useEffect, useState } from 'react';
import { StepType, useTour } from '../../../Other/tour';
import { Box, Button, InlineStack, Link, Text, BlockStack } from '@shopify/polaris';
import { DI } from '../../../../Core';
import { t } from 'i18next';

const TourListingSteps = (props: any) => {
    const { setSteps, setIsOpen, setTourLoading, setCurrentStep, isOpen } = useTour();
    const [tourPart, setTourPart] = useState(0);

    const endTour = () => {
        props.setActivateTour(false);
        props.di.globalState.removeLocalStorage('uploadTour')
        props.di.POST('connector/config/saveConfig', {
            data: [
                {
                    data: JSON.parse(
                        JSON.stringify(
                            {
                                listing_tour_1_visited: true,
                                listing_tour_2_visited: true,
                                listing_tour_3_visited: true,
                            }
                        )
                    ),
                    group_code: 'tour',
                },
            ],
        }
        )
            .then((response: any) => {
                setCurrentStep(-1);
                setIsOpen(false);
                props.di.globalState.removeLocalStorage('start_tour');
                if (response.success)
                    return;
                props.error(
                    'Failed to end tour'
                );
            });
    }

    const steps: StepType[] = [
        {
            selector: '.ced-tour-step--0',
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("This tour is about 'Product Upload,' which essentially involves listing Shopify products on Amazon. There are two ways to accomplish this: creating a new listing or making an offer on an existing Amazon listing. To determine the suitable listing method, we'll perform an Amazon Lookup process. To begin, simply click 'Next.'")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true,
            },
            OnClose() {
                endTour();
            },
            footer(props) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { props?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { props?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { props?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '.custom-tabs__wrapper', content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Here you can find a segmentation of products based on their current status, which includes categories such as 'Not Listed,' 'Inactive,' 'Incomplete,' or 'Active.'")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            disableScroll: true,
            OnClose() {
                endTour();
            },
            footer(props) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { props?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { props?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { props?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '.custom-tabs__wrapper #not_listed',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("To initiate the product listing process, you'll need to locate products categorized under 'Not Listed' Status")}
                        </Text>
                        <Text as='p'>
                            {t("Please click on ")} <Text as='span' fontWeight='semibold'>{t("Not Listed")}</Text> {t("to discover the Shopify products you wish to upload on Amazon.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                next: props?.selected !== 1
            },
            stepInteraction: true,
            disableScroll: true,
            OnClose() {
                endTour();
            },
            footer(prps) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { prps?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { prps?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { prps?.nextClick() }} disabled={props?.selected !== 1}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '.ant-table-row.ant-table-row-level-0',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Let's opt for this product to upload on Amazon. If you're satisfied with this selection, click")} <Text as='span' fontWeight='semibold'>{t("Next")}</Text> {t("to proceed.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            OnClose() {
                endTour();
            },
            footer(props) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { props?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { props?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { props?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '.ant-table-row.ant-table-row-level-0 .ant-checkbox-input',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Mark the checkbox to select product and click on")} <Text as='span' fontWeight='semibold'>{t("Next")}</Text> {t("to continue.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            stepInteraction: true,
            hideActions: {
                next: props.selectedLength <= 0,
            },
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled={props.selectedLength <= 0}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '#popoverActivator',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Once you've chosen a product, you'll need to click on")} <Text as='span' fontWeight='semibold'>{t("Select Actions")}</Text>, {t("where you'll find a comprehensive list of actions associated with that product.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            stepInteraction: true,
            hideActions: {
                next: true
            },
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '#amazonLookup',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Amazon Lookup")}</Text>
                        <Text as="p">
                            {t("Select")} <Text as='span' fontWeight='semibold'>{t("Amazon Lookup")}</Text> {t("to verify the uniqueness of your product's barcodes for offer listing.. If your barcodes are not unique and are listed on Amazon, your product becomes eligible for offer listing. This will update its status from 'Not Listed' to 'Not Listed: Offer'.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                next: true
            },
            stepInteraction: true,
            disableScroll: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '#upload_tour.Polaris-Button.Polaris-Button--variantPrimary',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Click")} <Text as='span' fontWeight='semibold'>{t("Proceed")}</Text> {t("to initiate the lookup process.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                next: true,
                back: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Product successfully looked up on Amazon for offer listing.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '.ant-table-row.ant-table-row-level-0 .status',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Verify your product status here. Amazon lookup product status changes from ‘Not Listed' to 'Not Listed: Offer' in case product's barcode is matched from products already listed on Amazon.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true
            },
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '.ant-table-row.ant-table-row-level-0 .product_title',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("To proceed with uploading the product, it's essential to verify that all details are accurate and complete. To accomplish this, the next step is to edit the product details. Simply click on the Product title to access the product edit page.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                next: true,
                back: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        }
    ]

    const steps2: StepType[] = [
        {
            selector: '#tour.table-wrapper .ant-table-tbody',
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Product Upload: For product upload, simply select the Shopify product by clicking on checkbox to list on Amazon and click")} <Text as='span' fontWeight='semibold'>{t("Next")}</Text>.
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true,
                next: props.selectedLength <= 0,
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled={props.selectedLength <= 0}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '#popoverActivator',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Now click on")} <Text as='span' fontWeight='semibold'>{t("Select Action")}s</Text> {t("to choose an action.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            stepInteraction: true,
            hideActions: {
                next: true
            },
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        }, {
            selector: '#amazonUpload',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Choose the")} <Text as='span' fontWeight='semibold'>{t("Upload Product")}</Text> {t("option to upload and list Shopify product to Amazon Seller Central.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                next: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '#upload_tour.Polaris-Button.Polaris-Button--variantPrimary',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Click on")} <Text as='span' fontWeight='semibold'>{t("Confirm")}</Text> {t("to proceed.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                next: true,
                back: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Please keep an eye out for a confirmation message at the bottom, verifying the successful initiation of the product upload process.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '.ant-table-row.ant-table-row-level-0 .activity',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Examine the 'Activity' column within the selected product's row to determine the current status of the operation. Once the product gets uploaded, their product status will be modified to “Listed”.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true
            },
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Congratulations, the product upload tour is over. Please let us know if you need further assistance")} <Link onClick={() => {
                                endTour()
                                props.history('../../panel/user/support')
                            }}>{t("here")}</Link>.
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true
            },
            OnNext: () => {
                setCurrentStep(-1)
                setIsOpen(false)
                props.setActivateTour(false);
                props.di.globalState.removeLocalStorage('uploadTour')
                props.di.POST('connector/config/saveConfig', {
                    "data": [
                        {
                            data: JSON.parse(JSON.stringify({ listing_tour_1_visited: true, listing_tour_2_visited: true, listing_tour_3_visited: true })),
                            group_code: "tour"
                        }
                    ]
                }).then((response: any) => {
                    if (response.success) return;
                    // props.error('Failed to end tour')
                })
            },
            nextIsClose: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='end'>
                            {/* <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{("End Tour")}</Button> */}
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { endTour() }}>{t("Finish")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        }
    ]

    useEffect(() => {
        if (props?.di?.globalState?.get('start_tour') !== 'single_product_upload') return;
        if (props.activateTour && JSON.parse(props.di.globalState.get('uploadTour'))?.part == '1') {
            setSteps?.(steps)
            setTourPart(0)
            setIsOpen(true)
            setCurrentStep(0)
        } else if (props.activateTour && JSON.parse(props.di.globalState.get('uploadTour'))?.part == '3') {
            setSteps?.(steps2)
            setTourPart(1)
            setIsOpen(true)
            setCurrentStep(0)
        } else {
            setSteps?.([])
            setIsOpen(false)
            props.setActivateTour(false);
            // props.di.globalState.removeLocalStorage('uploadTour')
            setTourLoading(false)
            setCurrentStep(-1)
        }
    }, [props?.activateTour])

    useEffect(() => {
        if (props?.di?.globalState?.get('start_tour') !== 'single_product_upload') return;
        props.loading && isOpen && setTourLoading(true)
    }, [props?.loading])

    useEffect(() => {
        if (props?.di?.globalState?.get('start_tour') !== 'single_product_upload') return;
        tourPart === 0 && isOpen && setSteps?.(steps)
        tourPart === 1 && isOpen && setSteps?.(steps2)
    }, [props.selectedLength, props?.selected])

    // useEffect(() => {
    //    if (props?.rows?.length <= 0 && inProgress && !props?.loading) {
    //         setSteps?.([])
    //         setIsOpen(false)
    //         props.setActivateTour(false);
    //         //props.di.globalState.removeLocalStorage('uploadTour')
    //         setTourLoading(false)
    //         setCurrentStep(-1)
    //         //props?.error("No product for uploading.")
    //     }
    // },[props?.rows])

    return null
};

export default DI(TourListingSteps);